import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  customsHeader: {
    description: 'orderDrawer.customs.header',
    defaultMessage: 'Customs Declarations',
    id: 'TSRh3D',
  },
  error: {
    description: 'orderDrawer.customs.error',
    defaultMessage: 'Error',
    id: 'oFogXp',
  },
});
